export default __webpack_public_path__ + "static/media/Boots of the Clay.39d70f9b.jpg";